import React, { useRef } from "react";
import { ArrowShapeUpFromLine, Xmark } from "@gravity-ui/icons";
import Toast from "../generic_components/Toast";
import { usePostHog } from "posthog-js/react";

const ModalContent = ({
  title,
  description,
  fileTypes,
  handleFileChange,
  closeModal,
  toastMessage,
  setToastMessage,
}) => {
  const dropRef = useRef(null);
  const posthog = usePostHog();

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile) {
      const fileEvent = {
        target: { files: [droppedFile] },
      };
      handleFileChange(fileEvent);
    } else {
      console.error("No file dropped");
      if (setToastMessage && typeof setToastMessage === 'function') {
        setToastMessage({ type: "error", message: "No file dropped." });
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    // posthog.capture("Drag-fileUpload")
  };

  const hasValidToast = toastMessage && typeof toastMessage === 'object' && typeof toastMessage.message === 'string';

  return (
    <div className="relative text-left bg-[#1d1b1d] border border-solid border-[#3c393c] rounded-lg w-full md:w-[32rem] self-center z-10">
      <h2 className="text-lg font-normal text-left w-full px-3 pt-3 pb-1">
        {title}
      </h2>
      {description && Array.isArray(description) && (
        <div className="px-3 pb-2 text-sm text-gray-400 font-extralight">
          <p className="font-normal text-gray-300 mb-1">Here's what we do:</p>
          <ul className="list-disc list-inside ml-1">
            {description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
      <div className="w-full border-t border-t-[#3c393c] mb-3"></div>
      <div
        ref={dropRef}
        className="border-dashed m-3 border-2 border-[#3c393c] px-5 py-5 rounded-md text-center"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <ArrowShapeUpFromLine className="w-[35px] h-[34.999515533447266px] text-white mx-auto mb-3" />
        <p className="mb-1 text-base font-extralight">
          Drop your content here or{" "}
          <label
            htmlFor="fileInput"
            className="text-white cursor-pointer font-semibold"
          >
            Browse
          </label>
        </p>
        <input
          type="file"
          accept={fileTypes?.join(",") || "*/*"}
          onChange={handleFileChange}
          className="hidden"
          id="fileInput"
        />
        <p className="text-gray-400 font-extralight text-sm">
          File supported: {fileTypes?.join(", ") || "any"}
        </p>
        <p className="text-gray-400 font-extralight text-sm">File size: max 20 MB</p>
      </div>
      {hasValidToast && (
        <Toast
          type={typeof toastMessage.type === 'string' ? toastMessage.type : "info"}
          message={toastMessage.message}
          onClose={setToastMessage && typeof setToastMessage === 'function' ? () => setToastMessage(null) : undefined}
        />
      )}
    </div>
  );
};

export default ModalContent;
